import { ConfigStore } from '~/code/config'
import { postWithToken } from '~/code/services'
import { SendFeedbackReq, SendFeedbackRes } from '../models'

export const sendFeedback = (transactionId: string, data: SendFeedbackReq) =>
    postWithToken<SendFeedbackRes>(`${ ConfigStore.getUrl().apiUrl }/transaction/events/${transactionId}`, data)